export default "__VITE_ASSET__BRUDu9st__"